import { render } from "./Restore.vue?vue&type=template&id=acefe4e4"
import script from "./Restore.vue?vue&type=script&setup=true&lang=js"
export * from "./Restore.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Restore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acefe4e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acefe4e4', __exports__)) {
    console.log('reload')
    api.reload('acefe4e4', __exports__)
  }
  
  module.hot.accept("./Restore.vue?vue&type=template&id=acefe4e4", () => {
    console.log('re-render')
    api.rerender('acefe4e4', render)
  })

}


export default __exports__